import { CardBody, Form, FormGroup, Input, Label, TabContent, TabPane } from "reactstrap";

import UserProfiles from "../../Apps/Users/UserProfiles";
import AttendanceMe from "../Attendance/AttendanceMe";
import { TabDatatype } from "../../../Types/UiKitsType";
import FtpImport from "./FtpImport";
import FtpExport from "./FtpExport";
import FtpImportLogs from "./FtpImportLogs";
import FtpExportLogs from "./FtpExportLogs";

export default function FTPTabContent({ tabId }: { tabId: string, }) {

    const borderData: TabDatatype[] = [
        {
            id: '1',
            text: <FtpImport/>

        },
        {
            id: '2',
            text: <FtpExport/>
        },
        {
            id: '3',
            text:<FtpImportLogs/>
        },
        {
            id: '4',
            text:<FtpExportLogs/>
        }
    ]
    return (
        <TabContent activeTab={tabId}>
            {borderData && borderData.map((item, index) => (
                <TabPane className={`fade ${tabId === item.id ? 'show' : ''}`} tabId={item.id} key={index}>
                    {item.text}
                </TabPane>
            ))}
        </TabContent>
    )
}
